import { Observable } from 'rxjs';
import { DashboardKpis } from '../models/dashboard.model';

export abstract class DashboardDataService {
  abstract getKpis(branchId?: string): Observable<DashboardKpis>;
}
